import { useSelector } from "react-redux";

export const useCheckPosSetting = (Flex1) => {

    const userData = useSelector((state) => state.authReducer);

    let SettingValue = userData?.posSettingList?.find(a => a.Flex1 == Flex1)?.SettingValue ?? false;

    return SettingValue;
};